<button type="button" class="news-card" [class.news-card-focused]="focused"
        [attr.aria-label]="'Read ' + newsText" (click)="openModal(content)">
  <span class="img-wrap news-thumbnail">
    <img [businessImage]="imageSrc" alt="" loading="lazy" decoding="async" />
  </span>
  <span class="txt-fnws-dv news-copy">
    <span class="date">{{ date }}</span>
    <span class="news-text">{{ newsText }}</span>
    <span class="news-info">{{ newsInfo }}</span>
    <span *ngIf="buttons?.length" class="btn-grps news-tags">
      <span *ngFor="let button of buttons" class="btn-chips btn-primary-light">{{ button }}</span>
    </span>
  </span>
</button>

<ng-template class="custom-modal custom-coupon-modal" #content let-modal>
  <button 
    type="button" 
    class="btn-close" 
    aria-label="Close" 
    (click)="modal.dismiss('Cross click')">
    <span></span>
    <span></span>
  </button>
  <div class="modal-body">
    <section class="article-card-section">
      <div class="article-row-card">
        <div class="article-left-card article-title">
          <div class="article-left-card-inner">
            <div class="btn-grps">
              <ng-container *ngFor="let button of buttons">
                <app-button 
                  [btnType]="'button'" 
                  [btnText]="button" 
                  [btnTitle]="button"
                  [btnCss]="'btn-chips btn-primary-light'">
                </app-button>
              </ng-container>
            </div>
            <div class="article-title-dv">
              <h2 class="title-font">{{ newsText }}</h2>
              <p>{{date}}</p>
            </div>
            <div class="article-desc-dv article-desc">
              <p> {{ newsInfo }}</p>
            </div>
            <div class="article-time-dv content-between">
              <div class="article-time-left">
                <!--<div class="article-time-cnt">
                  <div class="icon-dv"><img src="./assets/images/ic-clock-outline.svg" alt="clock-outline" class="img-clock" /></div>
                  <div class="txt-dv"><b>8:00 pm,</b> <span>June 4</span></div>
                </div>-->

                <p>{{restaurantDetails?.address1}}</p>
              </div>
              <div class="btn-blk-dv btn-50">
                <button class="btn btn-primary border-white" (click)="navigateToRestaurant()">Go to Restaurant</button>
              </div>
            </div>
          </div>
          <!-- <p>{{ newsInfo }}</p> -->
        </div>
        <div class="article-right-card">
          <img [src]="popupImageSrc" alt="article image" class="img-fluid img-article-full" />
        </div>
      </div>
    </section>
    <!-- coupon-card-section3 -->
    <section class="coupon-card-section d-none">
      <span class="color-bar"></span>
      <div class="coupon-card">
        <div class="coupon-left-card">
          <img [src]="imageSrc" alt="article image" class="img-fluid img-coupon-full" />
        </div>

        <div class="coupon-right-card">
          <div class="coupon-text-dv">
            <h2>Holidays Sushi</h2>
            <div class="badge-coupon-dv">
              <span class="badge-coupon badge-red"><b>20%</b></span>
              <span class="badge-coupon badge-blue">25 points 
                <svg class="points-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.58667 7.20046H8.78817V6.40093C8.78817 6.18888 8.70404 5.98551 8.55429 5.83557C8.40455 5.68563 8.20144 5.60139 7.98967 5.60139C7.77789 5.60139 7.57479 5.68563 7.42504 5.83557C7.27529 5.98551 7.19116 6.18888 7.19116 6.40093V7.20046H6.39266C6.18088 7.20046 5.97778 7.2847 5.82803 7.43464C5.67828 7.58458 5.59416 7.78795 5.59416 8C5.59416 8.21205 5.67828 8.41542 5.82803 8.56536C5.97778 8.7153 6.18088 8.79954 6.39266 8.79954H7.19116V9.59907C7.19116 9.81112 7.27529 10.0145 7.42504 10.1644C7.57479 10.3144 7.77789 10.3986 7.98967 10.3986C8.20144 10.3986 8.40455 10.3144 8.55429 10.1644C8.70404 10.0145 8.78817 9.81112 8.78817 9.59907V8.79954H9.58667C9.79845 8.79954 10.0016 8.7153 10.1513 8.56536C10.301 8.41542 10.3852 8.21205 10.3852 8C10.3852 7.78795 10.301 7.58458 10.1513 7.43464C10.0016 7.2847 9.79845 7.20046 9.58667 7.20046ZM15.7431 7.43233L13.8667 5.60139V2.91495C13.8667 2.7029 13.7825 2.49953 13.6328 2.34959C13.483 2.19965 13.2799 2.11541 13.0682 2.11541H10.4251L8.5566 0.236502C8.48237 0.161562 8.39406 0.102081 8.29675 0.0614899C8.19945 0.0208985 8.09508 0 7.98967 0C7.88425 0 7.77989 0.0208985 7.68258 0.0614899C7.58528 0.102081 7.49696 0.161562 7.42273 0.236502L5.59416 2.11541H2.91118C2.69941 2.11541 2.4963 2.19965 2.34656 2.34959C2.19681 2.49953 2.11268 2.7029 2.11268 2.91495V5.60139L0.236196 7.43233C0.161354 7.50666 0.101949 7.59509 0.0614105 7.69252C0.0208715 7.78995 0 7.89445 0 8C0 8.10555 0.0208715 8.21005 0.0614105 8.30748C0.101949 8.40491 0.161354 8.49334 0.236196 8.56767L2.11268 10.4386V13.0851C2.11268 13.2971 2.19681 13.5005 2.34656 13.6504C2.4963 13.8004 2.69941 13.8846 2.91118 13.8846H5.59416L7.46265 15.7635C7.53689 15.8384 7.6252 15.8979 7.72251 15.9385C7.81981 15.9791 7.92418 16 8.02959 16C8.135 16 8.23937 15.9791 8.33668 15.9385C8.43398 15.8979 8.5223 15.8384 8.59653 15.7635L10.465 13.8846H13.1081C13.3199 13.8846 13.523 13.8004 13.6727 13.6504C13.8225 13.5005 13.9066 13.2971 13.9066 13.0851V10.4386L15.7831 8.56767C15.8554 8.49074 15.9117 8.40022 15.9489 8.30136C15.986 8.20249 16.0032 8.09723 15.9995 7.99167C15.9958 7.8861 15.9712 7.78231 15.9272 7.68631C15.8832 7.5903 15.8207 7.50398 15.7431 7.43233ZM12.5092 9.54311C12.4337 9.61715 12.3737 9.70546 12.3326 9.8029C12.2915 9.90035 12.2701 10.005 12.2696 10.1108V12.2855H10.0977C9.99207 12.286 9.88756 12.3074 9.79024 12.3486C9.69292 12.3897 9.60473 12.4498 9.53078 12.5254L7.98967 14.0685L6.44855 12.5254C6.3746 12.4498 6.28641 12.3897 6.18909 12.3486C6.09178 12.3074 5.98726 12.286 5.88162 12.2855H3.70969V10.1108C3.70925 10.005 3.68785 9.90035 3.64673 9.8029C3.60561 9.70546 3.54559 9.61715 3.47014 9.54311L1.92902 8L3.47014 6.45689C3.54559 6.38285 3.60561 6.29454 3.64673 6.1971C3.68785 6.09965 3.70925 5.99501 3.70969 5.88922V3.71448H5.88162C5.98726 3.71405 6.09178 3.69262 6.18909 3.65145C6.28641 3.61027 6.3746 3.55017 6.44855 3.47462L7.98967 1.93152L9.53078 3.47462C9.60473 3.55017 9.69292 3.61027 9.79024 3.65145C9.88756 3.69262 9.99207 3.71405 10.0977 3.71448H12.2696V5.88922C12.2701 5.99501 12.2915 6.09965 12.3326 6.1971C12.3737 6.29454 12.4337 6.38285 12.5092 6.45689L14.0503 8L12.5092 9.54311Z" fill="white"/>
                </svg>
              </span>
            </div>
            <div class="desc-dv">
              <p>Savor the flavors of the ocean with our delectable sushi rolls, and enjoy a tantalizing discount with this exclusive coupon. Indulge in the freshest ingredients and culinary delights at our sushi restaurant while saving big with this limited-time offer.</p>
            </div>
          </div>
          <div class="btn-right-dv">
            <button class="btn btn-link-goto">Go to Restaurant</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-template>
